/* eslint-disable no-undef */
const DOCUMENT_AUTHORIZATION_TOKEN = 'accessToken';

export const setDocumentAuthorizationToken = (value) => {
  localStorage.setItem(DOCUMENT_AUTHORIZATION_TOKEN, value);
};

export const getDocumentAuthorizationToken = () => {
  return localStorage.getItem(DOCUMENT_AUTHORIZATION_TOKEN);
};
